import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    message: String,
    newChat: Boolean,
    chatId: String,
    chatUrl: String,
    messageDomId: String,
    fullscreen: Boolean,
  };

  open() {
    // Nav card showing an unread dot → open to the history list (so the operator lands on their unread
    // chat) instead of a fresh chat. Read live from the DOM so it stays correct after live badge
    // replaces swap the frame's contents. applyOpenIntent (on massimo:open) switches to the history tab.
    const openToHistory = !this.chatIdValue && Boolean(this.element.querySelector("[data-mo-unread-dot]"));

    if (this.chatIdValue) {
      sessionStorage.setItem("massimo-chat-id", this.chatIdValue);
      sessionStorage.removeItem("massimo-source");
      if (this.messageDomIdValue) this.#scrollToMessageOnLoad(this.messageDomIdValue);
      // The router only reads massimo-chat-id on first load, so retarget a loaded chat frame directly.
      const innerFrame = document.getElementById("massimo-chat-content");
      if (innerFrame && this.chatUrlValue) innerFrame.src = this.chatUrlValue;
    } else if (openToHistory) {
      sessionStorage.setItem("massimo-chat-id", "history");
      sessionStorage.removeItem("massimo-source");
      sessionStorage.removeItem("massimo-prompt");
      sessionStorage.removeItem("massimo-files");
    } else {
      const wantsNewChat = this.newChatValue || Boolean(this.messageValue);
      if (wantsNewChat) {
        sessionStorage.setItem("massimo-chat-id", "new");
        // Ordinary open — drop any pending rec source or Home upload so it can't pair with this chat.
        sessionStorage.removeItem("massimo-source");
        sessionStorage.removeItem("massimo-files");
      }
      if (this.messageValue) {
        sessionStorage.setItem("massimo-prompt", this.messageValue);
      } else if (wantsNewChat) {
        // Opening an unseeded new chat: clear any prompt a prior seeded opener left pending so it can't leak in.
        sessionStorage.removeItem("massimo-prompt");
      }
    }
    // Inline-fullscreen intent rides the event detail rather than sessionStorage: fullscreen_controller
    // only reads sessionStorage on page load, and Home clears massimo-fullscreen as it renders
    // (@suppress_restored_massimo), so a reload-based hand-off can't work from there.
    window.dispatchEvent(
      new CustomEvent("massimo:open", { detail: { fullscreen: openToHistory ? false : this.fullscreenValue } }),
    );
  }

  // Scrolls to a specific message once the chat transcript (re)loads — covers both retargeting
  // an already-open panel and the cold-open path, where chat_router sets the frame's src later.
  #scrollToMessageOnLoad(id) {
    const onLoad = (event) => {
      if (event.target.id !== "massimo-chat-content") return;
      document.removeEventListener("turbo:frame-load", onLoad);
      window.dispatchEvent(new CustomEvent("massimo:scroll-to-message", { detail: { id } }));
    };
    document.addEventListener("turbo:frame-load", onLoad);
  }
}
